import React, { useEffect, useState, useRef, useCallback } from "react";
import { token } from "../features/TokenSlice";
import { useDispatch } from "react-redux";
import axios from "../axios";
import LoaderImg from '../img/logo/running.gif';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from "react-router-dom";
//import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const Login = (props) => {
  const dispatch = useDispatch();
  const [UserName, setUserName] = useState('');
  const [UserPassword, setUserPassword] = useState('');

  const [usernameError, setUsernameError] = useState();
  const [error, setError] = useState('');
  const [ErrFlag, setErrFlag] = useState(false)

  const [passwordError, setPasswordError] = useState();
  const [LoginLoader, setLoginLoader] = useState(false);
  const DivRef = useRef(null);
  const [GuestLoginFlag, setGuestLoginFlag] = useState(false);

  const [LoginType, setLoginType] = useState(1);
  const [UserEmail, setUserEmail] = useState('');
  const [UserMobile, setUserMobile] = useState('');

  const [UserMobileError, setUserMobileError] = useState('');
  const [UserEmailError, setUserEmailError] = useState('');
  const [UserMobileOtpError, setUserMobileOtpError] = useState('');
  const [UserEmailOtpError, setUserEmailOtpError] = useState('');
  
  const [MobileOtp, setMobileOtp] = useState(['', '', '', '']);
  const [EmailOtp, setEmailOtp] = useState(['', '', '', '']);
  const EmailInputRefs = useRef([]);
  const MobileInputRefs = useRef([]);
  
  const [MobileOptFlag, setMobileOptFlag] = useState(false);
  const [EmailOptFlag, setEmailOptFlag] = useState(false);

  const [timeLeft, setTimeLeft] = useState(30);
  const [MobileOptTimerFlag, setMobileOptTimerFlag] = useState(false);
  const [MobileOptResendFlag, setMobileOptResendFlag] = useState(false);

  const [EmailOptTimerFlag, setEmailOptTimerFlag] = useState(false);
  const [EmailOptResendFlag, setEmailOptResendFlag] = useState(false);

  const handleChange = (e, index, opt_flag) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 1);

    if (opt_flag === 'mobile') {
      const newOtp = [...MobileOtp];
      newOtp[index] = value;
      setMobileOtp(newOtp);

      if (value && index < 3) {
        MobileInputRefs.current[index + 1]?.focus();
      }
      localStorage.setItem("MobileOptValidate", newOtp.join(''))
      // setMobileOptValidate(combined4Otp);
    } else {
      const newOtp1 = [...EmailOtp];
      newOtp1[index] = value;
      setEmailOtp(newOtp1);

      if (value && index < 3) {
        EmailInputRefs.current[index + 1]?.focus();
      }
      localStorage.setItem("EmailOptValidate", newOtp1.join(''))
    }
     
  };

  const handleKeyDown = (e, index, opt_flag) => {
    if (e.key === 'Backspace') {

      if (opt_flag == 'mobile' && MobileOtp[index] === '' && index > 0) {
        MobileInputRefs.current[index - 1].focus();
      }else if (opt_flag == 'email' && EmailOtp[index] === '' && index > 0) {
        EmailInputRefs.current[index - 1].focus();
      }
    }
  };
// console.log(MobileOptValidate);


  const HandleSendOtp = () => {
    
    var Validateflag = true;
    if(LoginType == 2){  // Mobile
      setUserMobileError("");
      if (UserMobile === "") {
        setUserMobileError("Please enter mobile number.");
        Validateflag = false;
      }else if(UserMobile.length < 10){
        setUserMobileError("Please enter 10 digit mobile number.");
        Validateflag = false;
      }
    }else if(LoginType == 3){  // Email
      setUserEmailError("");
      if (UserEmail === "") {
        setUserEmailError("Please enter email id.");
        Validateflag = false;
      }

      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(UserEmail)) {
        setUserEmailError('Please enter a valid email address.');
        Validateflag = false;
      }
    }

    if(Validateflag) {
        setLoginLoader(true);
         
      axios.post("user_send_otp", {
          Mobile: UserMobile,
          Email: UserEmail,
          LoginType: LoginType,
        })
        .then((response) => {
          //console.log(response.data.data.OrgUserAccessModules)
          if (response.data.status === 200) {
            //  console.log(response.data.data);
            localStorage.setItem("ID", response.data.data.user_id);
            if(response.data.error === 0){
              setTimeLeft(30);
              if(LoginType == 2){
                setMobileOtp(['', '', '', '']);
                setMobileOptFlag(true);
                setMobileOptResendFlag(false);
                setMobileOptTimerFlag(true);
                setUserMobileOtpError('');
              }else if(LoginType == 3){
                setEmailOptFlag(true);
                setEmailOptResendFlag(false);
                setEmailOptTimerFlag(true);
                setEmailOtp(['', '', '', '']);
                setUserEmailOtpError('');
              }
              toast.success(response.data.message);
              setLoginLoader(false);
            }else{
              if(LoginType == 2){
                setUserEmailError('');
                setUserMobileError(response.data.message);
              }else if(LoginType == 3){
                setUserMobileError('');
                setUserEmailError(response.data.message);
              }
              setLoginLoader(false);
            }
          }
          setLoginLoader(false);
        })
        .catch((response) => {
          // console.log(response);
          setLoginLoader(false);
        });
            
    }
  }
// console.log(MobileOptFlag);
  const handleValidation = () => {

    var flag = true;
   
    if(LoginType === 2){
      const LocalMobileOpt = localStorage.getItem('MobileOptValidate') ? localStorage.getItem('MobileOptValidate') : 0;
      // console.log(LocalMobileOpt);
      if (LocalMobileOpt === 0 || LocalMobileOpt.length < 4) {
        setUserMobileOtpError("Please enter the full 4-digit OTP."); 
        flag = false;
      }else{
        setUserMobileOtpError("");
      }
    } 

    if(LoginType === 3){
      const LocalEmailOpt = localStorage.getItem('EmailOptValidate') ? localStorage.getItem('EmailOptValidate') : 0;
      // console.log(LocalEmailOpt);
     
      if (LocalEmailOpt === 0 || LocalEmailOpt.length < 4) {
        setUserEmailOtpError("Please enter the full 4-digit OTP."); 
        flag = false;
      }else{
        setUserEmailOtpError("");
      }
    } 
    
    const GuestLoginFlag1 = localStorage.getItem('GuestLoginFlag') ? localStorage.getItem('GuestLoginFlag') : 0;
    //  console.log(props.AllowGuestLogin  , GuestLoginFlag1);
    if ((props.AllowGuestLogin && props.AllowGuestLogin == 1) && GuestLoginFlag1 === '1') {
      flag = true;
    }else {
     // console.log(1);
        if(LoginType === 1){
         // console.log(2, LoginType);
          setUsernameError("");
          setPasswordError("");
          if (UserName === "") {
            setUsernameError("Please enter Email id.");
            flag = false;
          }

          if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(UserName)) {
            setUsernameError('Please enter a valid email address.');
            flag = false;
          }
          if (UserPassword === "") {
            setPasswordError("Please enter password.");
            flag = false;
          }
        }
    }

    return flag;
  }
  
  // , [UserName, UserPassword, setUsernameError, setPasswordError]);

//  console.log(props.AllowGuestLogin  , GuestLoginFlag);
//  const handleSubmit = useCallback((e) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const flag = handleValidation();
      // console.log("Flag is", flag);
    if (flag) {
      setLoginLoader(true);
      
      let payload = {};
      
      //---------- Guest Login
      if(GuestLoginFlag && props.AllowGuestLogin === 1){
        payload = {
          LoginType: 1,
          Email: props.AllowGuestLogin === 1 ? props.GuestLoginUserEmail : '',
          Password: props.AllowGuestLogin === 1 ? '1234567a' : '',
        }
      }else{
        
        if(LoginType === 1){  //------- Username & Password Login
          payload = {
            LoginType: LoginType,
            Email: UserName,
            Password: UserPassword,
          }
        }
        //---------- Mobile Number Login
        if(LoginType === 2){
          payload = {
            LoginType: LoginType,
            Mobile: UserMobile,
            ValidOpt: localStorage.getItem('MobileOptValidate'),
          }
        }
        //---------- Email Number Login
        if(LoginType === 3){
          payload = {
            LoginType: LoginType,
            Email: UserEmail,
            ValidOpt: localStorage.getItem('EmailOptValidate'),
          }
        }
      }
      const GuestLoginFlag2 = localStorage.getItem('GuestLoginFlag') ? localStorage.getItem('GuestLoginFlag') : 0;
      // console.log(payload);
      axios.post("login", payload)
        .then((response) => {
        //  console.log(response)
          if (response.data.status === 200) {
            // console.log(response.data.user_id);
            if (parseInt(response.data.validate) === 0) {
              // console.log("validate is 0");
              props.setMsgFlag("Login");
              localStorage.setItem(
                "RacesToken",
                JSON.stringify({ token: response.data.data.token })
              );

              localStorage.setItem("ID", response.data.data.userData.id)
              // localStorage.setItem("EMAIL", response.data.data.userData.email)
              // localStorage.setItem("MOBILE", response.data.data.userData.mobile)

              if (response.data.data.OrgUserAccessModules) {
                // localStorage.setItem("OrgUserAccessModules", JSON.stringify(response.data.data.OrgUserAccessModules));
                localStorage.setItem("LoginAsOrganiser", response.data.data.userData.organizer_user)
              }
              // localStorage.setItem("Access_Right_Flag", response.data.data.AccessRightFlag);

              if (props.AllowGuestLogin === 1 && props.GuestUserId && GuestLoginFlag2 == 1) {
                localStorage.setItem("AllowGuestLogin", props.AllowGuestLogin);
                localStorage.setItem("GuestUserId", props.GuestUserId);
                localStorage.setItem("GuestLoginEventId", props.GuestLoginEventId);
                localStorage.removeItem('GuestLoginFlag');
                setGuestLoginFlag(false);      
              }

              dispatch(token({ token: response.data.data.token }));
              props.setOpen(false);
              props.setLoginWishlist(false);
              props.setWelcome(true);
              if (props.Login)
                props.setLogin(false)
            } else {
              // console.log("validate is 1")
              localStorage.setItem("ID", response.data.user_id)
              props.setOpen(false)
              props.setUserVerify(true)
              if (props.Login)
                props.setLogin(false)
              props.setLoginWishlist(false);
            }
            localStorage.removeItem('MobileOptValidate');
            localStorage.removeItem('EmailOptValidate');
            props.setOffCanvasMenu(false);
          }
          setLoginLoader(false);
        })
        .catch((error) => {
          
          if (error.response.status == 400) {

            if(error.response.data.validate == 2){
              
              if(LoginType == 2){
                setUserMobileOtpError(error.response.data.message);
              }else if(LoginType == 3){
                setUserEmailOtpError(error.response.data.message);
              }else{
                setErrFlag(true);
                setError(error.response.data.message);
              }
            }else{
              setErrFlag(true);
              setError(error.response.data.message);
            }
          }
          setLoginLoader(false);
          // localStorage.removeItem('MobileOptValidate');
          // localStorage.removeItem('EmailOptValidate');
        });
    }
  }
  // }, [UserName, UserPassword, handleValidation, props, dispatch, GuestLoginFlag]);

  const handleClose = (e) => {
    if (DivRef.current && !DivRef.current.contains(e.target)) {
      // props.setOpen(false);
    }
  }

  useEffect(() => {
    const handleEscKeyPress = (event) => {
      if (event.key === 'Escape') {
        props.setOpen(false);
        props.setLoginWishlist(false);
      }
    };
    document.addEventListener('keydown', handleEscKeyPress);
    return () => {
      document.removeEventListener('keydown', handleEscKeyPress);
    };
  }, [props, props.setOpen]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        // console.log(UserName, UserPassword);
        handleSubmit(e);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'auto';
    };
  }, [UserName, UserPassword, handleSubmit]);


  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordToggle = (e) => {
    e.preventDefault()
    setShowPassword(!showPassword);
  };

  const onSignIn = googleUser => {
    const profile = googleUser.getBasicProfile();
    console.log('ID: ' + profile.getId());
    console.log('Name: ' + profile.getName());
    console.log('Image URL: ' + profile.getImageUrl());
    console.log('Email: ' + profile.getEmail());
  };

  const handleChangeTabs = (tab) => {
    
    setLoginType(tab);
    if(tab === 1){  // Username & Passsword
      setUserMobileError(''); setUserEmailError(''); setUserMobileOtpError(''); setUserEmailOtpError(''); setMobileOptFlag(false); setEmailOptFlag(false);
      setMobileOptTimerFlag(false); setMobileOptResendFlag(false);
      setEmailOptTimerFlag(false); setEmailOptResendFlag(false);
    }else if(tab === 2){  // Mobile Opt
      setUsernameError(''); setPasswordError(''); setUserEmailError(''); setUserEmailOtpError('');
      setEmailOptTimerFlag(false); setEmailOptResendFlag(false); setEmailOptFlag(false);
    }if(tab === 3){   // Email Opt
      setUsernameError(''); setPasswordError(''); setUserMobileError(''); setUserMobileOtpError(''); setMobileOptTimerFlag(false); setMobileOptResendFlag(false); setMobileOptFlag(false);
    }
    // console.log(tab);
  }

  const handleChangeGusetLogin = () => {
    setGuestLoginFlag(true);
    localStorage.setItem("GuestLoginFlag",1);
  }

  //---------- set opt timer
  useEffect(() => {
    let timer;

    if ((MobileOptTimerFlag || EmailOptTimerFlag)  && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prev => {
          if (prev === 1) {
            setMobileOptTimerFlag(false); 
            setMobileOptResendFlag(true);
            setEmailOptTimerFlag(false); 
            setEmailOptResendFlag(true);
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [MobileOptTimerFlag,EmailOptTimerFlag, timeLeft]);
  // console.log(timeLeft);
  return (
    <>
    {LoginLoader ? <div id='loader' style={{ backgroundImage: `url(${LoaderImg})`, zIndex: '99999' }}></div> : null}
      <ToastContainer theme="colored" />

      <div className="modal is-visible" data-animation="slideInUp" onClick={(e) => { handleClose(e) }}>
        <div className="modal-dialog quickview__main--wrapper">
          <header className="modal-header quickview__header">
            {/* <button className="close-modal quickview__close--btn" aria-label="close modal" data-close onClick={() => {
              props.setOpen(false);
            }}>✕ </button> */}
          </header>
          <div className="quickview__inner">
            <div className="row">

              <div className="login__section">

                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="login__section--inner" ref={DivRef}>
                    <div className="p-4">
                      <div className="account__login--header">
                        <h3 className="account__login--header__title mb-10">Log In</h3>
                        <p className="account__login--header__desc">Your all-in-one event registering tool</p>
                      </div>

                      <div className="login-ui mt-4">

                        <ul>
                          <li className="m-2" onClick={() => {
                            handleChangeTabs(1); setUserEmail(''); setUserMobile('');
                          }} >
                            <a className={LoginType === 1 ? "py-3 li-active" : "py-3"}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" ><path d="M80-200v-80h800v80H80Zm46-242-52-30 34-60H40v-60h68l-34-58 52-30 34 58 34-58 52 30-34 58h68v60h-68l34 60-52 30-34-60-34 60Zm320 0-52-30 34-60h-68v-60h68l-34-58 52-30 34 58 34-58 52 30-34 58h68v60h-68l34 60-52 30-34-60-34 60Zm320 0-52-30 34-60h-68v-60h68l-34-58 52-30 34 58 34-58 52 30-34 58h68v60h-68l34 60-52 30-34-60-34 60Z" /></svg> <span>User ID</span>
                            </a>
                          </li>
                          <li className="m-2" onClick={() => {
                            handleChangeTabs(2); setUserEmail(''); setUserName(''); setUserPassword('');
                          }}>
                            <a className={LoginType === 2 ? "py-3 li-active" : "py-3"}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" ><path d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v124q18 7 29 22t11 34v80q0 19-11 34t-29 22v404q0 33-23.5 56.5T680-40H280Zm0-80h400v-720H280v720Zm0 0v-720 720Zm200-40q17 0 28.5-11.5T520-200q0-17-11.5-28.5T480-240q-17 0-28.5 11.5T440-200q0 17 11.5 28.5T480-160Z" /></svg> <span>Mobile Number</span>
                            </a>
                          </li>
                          <li className="m-2" onClick={() => {
                            handleChangeTabs(3); setUserMobile(''); setUserName(''); setUserPassword('');
                          }}>
                            <a className={LoginType === 3 ? "py-3 li-active" : "py-3"}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z" /></svg> <span>Email ID</span>
                            </a>
                          </li>
                        </ul>

                        {/* User ID and Password */}
                        <div className={LoginType === 1 ? "login-option active" : "login-option"}>
                          <div className="input-group my-4">
                            <label className="mb-3">Enter Email</label>
                            <input className="account__login--input mb-2" placeholder="Email Id" type="email" name="username"
                              onChange={(e) => { setUserName(e.target.value) }} onClick={() => setErrFlag(false)}
                              autoComplete="off"
                              value={UserName} />
                            <small className="text-danger mb-0">{usernameError}</small>
                          </div>

                          <div className="input-group my-4">
                            <label className="mb-3">Enter Password </label>
                            <input
                              className="account__login--input mb-2"
                              placeholder="Password"
                              type={showPassword ? 'text' : 'password'}
                              name="password"
                              autoComplete="off"
                              onChange={(e) => { setUserPassword(e.target.value) }}
                              onClick={() => setErrFlag(false)}
                              value={UserPassword}
                            />
                            {showPassword ?
                              <div className="tooltip">
                                <svg onClick={(e) => handlePasswordToggle(e)} style={{ position: "absolute", right: "10px", cursor: "pointer", top: "12px" }} xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"><path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" />
                                </svg>
                                <span className="tooltiptext position-fixed border-radius-10 p-4 w-auto" style={{right:"90px"}}>Hide</span>
                              </div>

                              :
                              <div className="tooltip">
                                <svg onClick={(e) => handlePasswordToggle(e)} style={{ position: "absolute", right: "10px", cursor: "pointer", top: "12px" }} xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30"><path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" /></svg>
                                <span className="tooltiptext position-fixed border-radius-10 p-4 w-auto" style={{right:"90px"}}>Show</span>
                              </div>
                            }

                            <small className="text-danger mb-0">{passwordError}</small>
                          </div>

                          {ErrFlag ?
                            <div className="text-danger mb-0" style={{ "textAlign": "center" }} id="err">{error}</div>
                            : null}


                          <div className="row">
                            <div className="col-sm-6">
                              <button className="account__login--btn secondary__btn mt-2" onClick={() => {
                                props.setOpen(false); props.setLoginWishlist(false);
                              }}>Close</button>
                            </div>
                            <div className="col-sm-6">
                              <button className="account__login--btn primary__btn mt-2" type="submit">Continue</button>
                            </div>
                          </div>

                          <div className="w-100 m-0 mt-4" style={{textAlign:'right'}}>
                            
                              <p className="account__login--divide__text" onClick={(e) => {
                                props.setForgotPasswordFlag(true);
                                props.setOpen(false); props.setLoginWishlist(false);
                              }}>
                                
                                <span style={{display:'block', cursor:'pointer', color: '#da251c', fontSize: '16px'}} onMouseOver={e => (e.target.style.fontWeight = 'bold')} onMouseOut={e => (e.target.style.fontWeight = 'normal')}> Forgot Password?</span>
                              
                              </p>
                          
                          </div>

                        </div>
                        {/* ------------------- End ------------------- */}

                         {/* Mobile Number */}
                         
                        <div className={LoginType === 2 ? "login-option active" : "login-option"}>

                          <div className="input-group my-4" style={{ display: MobileOptFlag ? 'none' : 'flex' }}>
                            <label className="mb-3">Mobile Number </label>
                            <input className="account__login--input mb-2"  placeholder="Enter Mobile Number"
                                type="text" name="mobile_number"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  // Allow only digits and limit to 10 characters
                                  if (/^\d{0,10}$/.test(value)) {
                                    setUserMobile(value);
                                  }
                                }}
                                onClick={() => setErrFlag(false)} autoComplete="off" value={UserMobile}
                                maxLength={10} inputMode="numeric" pattern="\d*"
                              />
                              <small className="text-danger">{UserMobileError}</small>
                          </div>

                          {/* Close - Send OTP - Submit OTP  */}
                          <div className="row" style={{ display: MobileOptFlag ? 'none' : 'flex' }}>
                            <div className="col-sm-6">
                              <button className="account__login--btn secondary__btn mt-2" onClick={() => {
                                props.setOpen(false); props.setLoginWishlist(false);
                              }}>Close</button>
                            </div>
                            <div className="col-sm-6">
                              <button className="account__login--btn primary__btn mt-2" type="button" onClick={() => { HandleSendOtp(); }}>Send OTP</button>
                            </div>

                          </div>
                          
                          {/* Verify OTP */}
                          <div className="row mt-4" style={{ display: MobileOptFlag ? 'flex' : 'none' }}>
                            <h4 className="my-2">Verify OTP</h4>
                            <label className="my-2">Please enter the 4-digit code sent to you at <a> <strong>{UserMobile}</strong> <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000" onClick={(e) => setMobileOptFlag(false) }><path d="M80 0v-160h800V0H80Zm160-320h56l312-311-29-29-28-28-311 312v56Zm-80 80v-170l448-447q11-11 25.5-17t30.5-6q16 0 31 6t27 18l55 56q12 11 17.5 26t5.5 31q0 15-5.5 29.5T777-687L330-240H160Zm560-504-56-56 56 56ZM608-631l-29-29-28-28 57 57Z"/></svg></a></label>

                            {MobileOtp.map((digit, index) => (
                                <div key={index} className="col-3 col-sm-3 my-3">
                                  <div className="input-group">
                                    <input
                                      className="account__login--input mb-2 text-center"
                                      type="text"
                                      inputMode="numeric"
                                      maxLength={1}
                                      value={digit}
                                      onChange={(e) => handleChange(e, index, 'mobile')}
                                      onKeyDown={(e) => handleKeyDown(e, index, 'mobile')}
                                      ref={(el) => (MobileInputRefs.current[index] = el)}
                                      autoComplete="off"
                                    />
                                  </div>
                                </div>
                              ))}
                            <small className="text-danger mb-0">{UserMobileOtpError}</small>

                          </div>

                          {/* Resend OTP */}
                          <div className="row mb-4" style={{ display: MobileOptFlag ? 'flex' : 'none' }}>
                            
                            <div className="col-sm-12 text-center" style={{ display: MobileOptResendFlag ? 'block' : 'none' }}>
                               <label className="my-2">Didn't get the OTP ? <a onClick={() => { HandleSendOtp(); }} > <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"/></svg> <strong>Resend</strong></a></label>
                            </div>
                            <div className="col-sm-12 text-center" style={{ display: MobileOptTimerFlag ? 'block' : 'none' }}>
                               <label className="my-2">Didn't get the OTP ? <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000"><path d="M610-760q-21 0-35.5-14.5T560-810q0-21 14.5-35.5T610-860q21 0 35.5 14.5T660-810q0 21-14.5 35.5T610-760Zm0 660q-21 0-35.5-14.5T560-150q0-21 14.5-35.5T610-200q21 0 35.5 14.5T660-150q0 21-14.5 35.5T610-100Zm160-520q-21 0-35.5-14.5T720-670q0-21 14.5-35.5T770-720q21 0 35.5 14.5T820-670q0 21-14.5 35.5T770-620Zm0 380q-21 0-35.5-14.5T720-290q0-21 14.5-35.5T770-340q21 0 35.5 14.5T820-290q0 21-14.5 35.5T770-240Zm60-190q-21 0-35.5-14.5T780-480q0-21 14.5-35.5T830-530q21 0 35.5 14.5T880-480q0 21-14.5 35.5T830-430ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880v80q-134 0-227 93t-93 227q0 134 93 227t227 93v80Zm0-320q-33 0-56.5-23.5T400-480q0-5 .5-10.5T403-501l-83-83 56-56 83 83q4-1 21-3 33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Z"/></svg>
                               
                                <span style={{ fontWeight: 'bold' }}>
                                  {timeLeft < 10 ? `00:0${timeLeft}` : `00:${timeLeft}`}
                                </span>
                                </label>
                            </div>
                          </div>

                          {/* Close - Send OTP - Submit OTP  <strong>00:10</strong>  */}
                          <div className="row" style={{ display: MobileOptFlag ? 'flex' : 'none' }}>
                            <div className="col-sm-6">
                              <button className="account__login--btn secondary__btn mt-2" onClick={() => {
                                props.setOpen(false); props.setLoginWishlist(false);
                              }}>Close</button>
                            </div>
                            <div className="col-sm-6">
                              <button className="account__login--btn primary__btn mt-2" type="submit">Continue</button>
                            </div>
                          </div>

                        </div>

                        {/* Email ID */}
                        <div className={LoginType === 3 ? "login-option active" : "login-option"}>
                        
                          <div className="input-group my-4" style={{ display: EmailOptFlag ? 'none' : 'flex' }}>
                            <label className="mb-3">Email ID </label>
                            <input className="account__login--input mb-2" placeholder="Enter Email ID" type="email" name="email" autoComplete="off" onChange={(e) => { setUserEmail(e.target.value) }} onClick={() => setErrFlag(false)} value={UserEmail} />
                            <small className="text-danger mb-0">{UserEmailError}</small>
                          </div>
                          
                          {/* Close - Send OTP - Submit OTP  */}
                           <div className="row" style={{ display: EmailOptFlag ? 'none' : 'flex' }}>
                            <div className="col-sm-6">
                              <button className="account__login--btn secondary__btn mt-2" onClick={() => {
                                props.setOpen(false); props.setLoginWishlist(false);
                              }}>Close</button>
                            </div>
                            <div className="col-sm-6">
                              <button className="account__login--btn primary__btn mt-2" type="button" onClick={() => { HandleSendOtp(); }}>Send OTP</button>
                            </div>
                          </div>

                          {/* Verify OTP */}
                          <div className="row mt-4" style={{ display: EmailOptFlag ? 'flex' : 'none' }}>
                            <h4 className="my-2">Verify OTP</h4>
                            <label className="my-2">Please enter the 4-digit code sent to you at <a> <strong>{UserEmail}</strong> <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000" onClick={(e) => setEmailOptFlag(false) } ><path d="M80 0v-160h800V0H80Zm160-320h56l312-311-29-29-28-28-311 312v56Zm-80 80v-170l448-447q11-11 25.5-17t30.5-6q16 0 31 6t27 18l55 56q12 11 17.5 26t5.5 31q0 15-5.5 29.5T777-687L330-240H160Zm560-504-56-56 56 56ZM608-631l-29-29-28-28 57 57Z"/></svg></a></label>

                            {EmailOtp.map((digit, index) => (
                                <div key={index} className="col-3 col-sm-3 my-3">
                                  <div className="input-group">
                                    <input
                                      className="account__login--input mb-2 text-center"
                                      type="text"
                                      inputMode="numeric"
                                      maxLength={1}
                                      value={digit}
                                      onChange={(e) => handleChange(e, index, 'email')}
                                      onKeyDown={(e) => handleKeyDown(e, index, 'email')}
                                      ref={(el) => (EmailInputRefs.current[index] = el)}
                                      autoComplete="off"
                                    />
                                  </div>
                                </div>
                            ))}
                            <small className="text-danger mb-0">{UserEmailOtpError}</small>
                          </div>
                          
                          {/* Resend OTP */}
                          <div className="row mb-4" style={{ display: EmailOptFlag ? 'flex' : 'none' }}>
                            <div className="col-sm-12 text-center" style={{ display: EmailOptResendFlag ? 'block' : 'none' }}>
                               <label className="my-2">Didn't get the OTP ? <a onClick={() => { HandleSendOtp(); }} > <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"/></svg> <strong>Resend</strong></a></label>
                            </div>
                            <div className="col-sm-12 text-center" style={{ display: EmailOptTimerFlag ? 'block' : 'none' }}>
                               <label className="my-2">Didn't get the OTP ? <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000"><path d="M610-760q-21 0-35.5-14.5T560-810q0-21 14.5-35.5T610-860q21 0 35.5 14.5T660-810q0 21-14.5 35.5T610-760Zm0 660q-21 0-35.5-14.5T560-150q0-21 14.5-35.5T610-200q21 0 35.5 14.5T660-150q0 21-14.5 35.5T610-100Zm160-520q-21 0-35.5-14.5T720-670q0-21 14.5-35.5T770-720q21 0 35.5 14.5T820-670q0 21-14.5 35.5T770-620Zm0 380q-21 0-35.5-14.5T720-290q0-21 14.5-35.5T770-340q21 0 35.5 14.5T820-290q0 21-14.5 35.5T770-240Zm60-190q-21 0-35.5-14.5T780-480q0-21 14.5-35.5T830-530q21 0 35.5 14.5T880-480q0 21-14.5 35.5T830-430ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880v80q-134 0-227 93t-93 227q0 134 93 227t227 93v80Zm0-320q-33 0-56.5-23.5T400-480q0-5 .5-10.5T403-501l-83-83 56-56 83 83q4-1 21-3 33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Z"/></svg> 
                                <span style={{ fontWeight: 'bold' }}>
                                  {timeLeft < 10 ? `00:0${timeLeft}` : `00:${timeLeft}`}
                                </span>
                               </label>
                            </div>
                          </div>

                          {/* Close - Send OTP - Submit OTP  */}
                          <div className="row" style={{ display: EmailOptFlag ? 'flex' : 'none' }}>
                            <div className="col-sm-6">
                              <button className="account__login--btn secondary__btn mt-2" onClick={() => {
                                props.setOpen(false); props.setLoginWishlist(false);
                              }}>Close</button>
                            </div>
                            <div className="col-sm-6">
                              <button className="account__login--btn primary__btn mt-2" type="submit">Continue</button>
                            </div>
                          </div>

                        </div>

                        {/* Guest login - signup - T&C */}
                        <div className="text-center">

                          <div className="account__login--divide my-3">
                            <span className="account__login--divide__text" style={{display:'inline-block'}}>OR</span>
                          </div>

                          {/* Guest Login  */}
                          <div className="row d-flex justify-content-center">
                            <div className="col-sm-6">
                              {props.AllowGuestLogin === 1 && props.GuestUserId ? <button className="account__login--btn secondary__btn mt-2" onClick={() => { handleChangeGusetLogin(); }} >Guest Login</button>
                                : null}
                            </div>
                          </div>

                          <div className="my-2">
                            <div className="d-flex justify-content-center my-3">
                              <p className="m-0" style={{ marginTop: "10px" }}>Don’t have an account? {"  "} </p>
                            <p className="account__login--divide__text" style={{ fontSize: "18px" }} onClick={() => {
                              props.setSignUp(true);
                              props.setOpen(false);
                            }
                            }>
                             <span style={{display:'block', cursor:'pointer', color: '#da251c', fontSize: '16px'}} onMouseOver={e => (e.target.style.fontWeight = 'bold')} onMouseOut={e => (e.target.style.fontWeight = 'normal')}> Signup</span>
                            </p>
                            </div>
                          </div>

                          <p>By continuing, you agree to PASSILO. {" "}
                            <Link to="https://passilo.com/terms_conditions" target="blank" >  Terms of Services</Link> and <Link to="https://passilo.com/privacy_policy" target="blank"> Privacy Statement</Link>.
                            </p>

                        </div>

                      </div>

                     


                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
